// config.js
let apiUrl;

switch (process.env.NODE_ENV.trim()) {
  case "development":
    apiUrl = "https://sbgvm-151-69.in2p3.fr/chatso";
    break;
  case "docker":
    apiUrl = "http://backend";
    break;
  case "preproduction":
    apiUrl = "https://sbgvm-151-69.in2p3.fr/chatso";
    break;
  case "production":
    apiUrl = "/api";
    break;
  default:
    apiUrl = "/api";
}

const config = {
  apiUrl,
};

export default config;
